<form class="edit-form" [formGroup]="editForm" *ngIf="editForm">
  <section class="siteUrgencySection">
    <div class="site-field">
      <app-autocomplete [label]="'billing.articles.create.sender.label'"
        [control]="editForm.get('sender').get('address')" [list]="senders" errorMsg="orders.create.sender.errorMessage"
        [canString]="true">
      </app-autocomplete>
    </div>

    <div class="urgency-field">
      <app-autocomplete [label]="'billing.articles.create.urgency.label'" [control]="editForm.get('urgency')"
        [list]="urgencies" errorMsg="orders.create.urgency.errorMessage" [canString]="true">
      </app-autocomplete>
    </div>
  </section>




  <table formArrayName="steps">
    <tr>
      <th>Étape</th>
      <th>Jour</th>
      <th>Nuit</th>
      <th>Jour</th>
      <th>Nuit</th>
      <th>Jour</th>
      <th>Nuit</th>
      <th></th>
    </tr>

    <tr *ngFor="let control of getArray('steps').controls; index as i" [formGroupName]="i">
      <td class="stepCell">
        <app-autocomplete [control]="control.get('address')" [list]="steps" label="billing.articles.create.step.label"
          errorMsg="orders.create.receiver.errorMessage" [canString]="true">
        </app-autocomplete>
      </td>

      <td>
        <mat-form-field class="inputNumber">
          <input type="number" min="0" matInput formControlName="daysWeekDayPrice">
        </mat-form-field>
      </td>

      <td>
        <mat-form-field class="inputNumber">
          <input type="number" min="0" matInput formControlName="daysWeekNightPrice">
        </mat-form-field>
      </td>

      <td>
        <mat-form-field class="inputNumber">
          <input type="number" min="0" matInput formControlName="saturdayDayPrice">
        </mat-form-field>
      </td>

      <td>
        <mat-form-field class="inputNumber">
          <input type="number" min="0" matInput formControlName="saturdayNightPrice">
        </mat-form-field>
      </td>

      <td>
        <mat-form-field class="inputNumber">
          <input type="number" min="0" matInput formControlName="sundayDayPrice">
        </mat-form-field>
      </td>

      <td>
        <mat-form-field class="inputNumber">
          <input type="number" min="0" matInput formControlName="sundayNightPrice">
        </mat-form-field>
      </td>
      <td class="actionCell">
        <button *ngIf="i !== 0" type="button" matTooltip="Retirer le destinataire" mat-icon-button color="primary"
          (click)="onRemoveReceiver(i)">
          <mat-icon aria-label="delete">delete</mat-icon>
        </button>
      </td>
    </tr>
  </table>



  <div *ngIf="getArray('steps').controls.length < 8">
    <button type="button" mat-icon-button color="primary" matTooltip="Ajouter un destinataire"
      (click)="onAddReceiver()">
      <mat-icon aria-label="Add">add</mat-icon>
    </button>
  </div>

  <app-validate-and-cancel (submitEvent)="endForm($event)" [editForm]="editForm" class="actions"
    [disabling]="editForm.invalid"></app-validate-and-cancel>
</form>